import { PlanTypes, PlanTypesDisplay, PlanVMNewTypesDisplay } from 'mbs-ui-shared@models/PlanTypes.enum';
import { PlanInfo } from 'mbs-ui-shared@models/backup/plan-info-model';
import { RecoveryStatus } from 'mbs-ui-shared@models/backup/recovery-status.enum';

export class PlansUtil {
  public static getIcon(type: PlanTypes): string {
    switch (+type) {
      case PlanTypes.NA:
        return 'ico ico-question-circle';
      case PlanTypes.Plan:
      case PlanTypes.RestorePlan:
        return 'ico ico-file';
      case PlanTypes.BackupDiskImagePlan:
      case PlanTypes.RestoreDiskImagePlan:
        return 'ico ico-imagebased';
      case PlanTypes.DataBasePlan:
      case PlanTypes.RestoreDataBasePlan:
        return 'ico ico-databased';
      case PlanTypes.ExchangePlan:
      case PlanTypes.RestoreExchangePlan:
        return 'ico ico-exchange';
      case PlanTypes.BackupVMware:
      case PlanTypes.RestoreVMware:
      case PlanTypes.RestoreVMwareToCustom:
        return 'ico ico-vmware';
      case PlanTypes.BackupHyperV:
      case PlanTypes.RestoreHyperV:
      case PlanTypes.RestoreHyperVToCustom:
        return 'ico ico-hyperv';
      case PlanTypes.ConsistencyCheck:
        return 'ico ico-consistencycheck';
      default:
        return 'ico ico-file';
    }
  }

  public static getName(type: PlanTypes): string {
    return PlanTypesDisplay[type] || PlanVMNewTypesDisplay[type] || '';
  }

  public static isPlanRunning(plan: PlanInfo): boolean {
    return [RecoveryStatus.Started, RecoveryStatus.Running].includes(plan?.lastRunInfo?.status);
  }
  public static isOverdue(plan: PlanInfo): boolean {
    return !this.isPlanRunning(plan) && plan?.isOverdue;
  }

  public static extendedLastInfoStatus(plan: PlanInfo): RecoveryStatus {
    return this.isOverdue(plan) ? RecoveryStatus.Overdue : plan.lastRunInfo?.status;
  }
}
